import React, { useMemo } from 'react';
import styled from 'styled-components';
import { TimeCheckSvg } from '../../../assets/svg-icon-components/TimeCheckSvg';
import { TimeHalfPastSvg } from '../../../assets/svg-icon-components/TimeHalfPastSvg';
import { RhCard } from '../RhCard';
import { RhSelect, RhSelectOption } from '../RhSelect';
import { SizedBox } from '../SizedBox';
import { H2, Regular } from '../Styles';

type Props = {
  /** whether or not to show the description on the bottom */
  showDescription?: boolean;
  publishingStatusValue: string | null;
  onPublishingStatusChange: (selectedOption: RhSelectOption) => void;
};

const publishingStatusOptions = [
  { value: 'unpublished', label: 'Unpublished', icon: TimeHalfPastSvg },
  { value: 'published', label: 'Published', icon: TimeCheckSvg },
];

export const PublishingStatusCard: React.FC<Props> = props => {
  const selectedPublishingStatus = useMemo(
    () => publishingStatusOptions.find(option => option.value === props.publishingStatusValue),
    [props.publishingStatusValue]
  );
  return (
    <RhCard mode="tiled">
      <SizedBox height={2} />
      <DetailHeader>
        <H2>Publishing Status</H2>
      </DetailHeader>
      <SizedBox height={12} />
      <RhSelect
        value={selectedPublishingStatus}
        options={publishingStatusOptions}
        onChange={props.onPublishingStatusChange}
      />
      {props.showDescription && (
        <>
          <SizedBox height={12} />
          <Regular>
            This Bible Study Program is currently not viewable on the mobile app. Only you and Risen
            Hope admins can see this.
          </Regular>
        </>
      )}
    </RhCard>
  );
};

const DetailHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
